export default {
	methods: {
		/**
		 * @description 处理动态字段的值，把下拉类型的value处理成text显示。
		 * @param {array} dynamicKeyList 动态字段列表，含有字段的id，type
		 * @param {object} dynamicDataObj 动态字段的值，格式为{动态字段itemId: 值}
		 * @returns none 直接改变dynamicKeyList，给每个item加上value，用以显示。
		 */
		async handleValue2Text(dynamicKeyList, dynamicDataObj) {
			for (const item of dynamicKeyList) {
                const value = dynamicDataObj[item.id] || '';
                item.property = JSON.parse(item.property || "{}");
                item['sourceValue'] = value;

                if (item.type === 'dict') {
                    const { data: { data: dictData } } = await this.$server.getDictionary({ key: item.property.dictCode });
                    if (item.property.multi) {
                        const arr = [];
                        // TODO: CMS字典驼峰改下划线后，删掉obj['name' + this.$lang]
                        dictData.forEach(item2 => {
                            if (value.includes(item2.value)) {
                                arr.push(item2['name' + this.$lang] || item2['name' + this.$lang2]);
                            }
                        })
                        item.value = arr.join();
                    } else {
                        const valueData = dictData.find(item2 => value.includes(item2.value))?.['name' + this.$lang2];
                        // TODO: CMS字典驼峰改下划线后，删掉valueData['name' + this.$lang]
                        item.value = valueData['name' + this.$lang] || valueData['name' + this.$lang2]
                    }
                } else if (item.type === 'select') {
                    if (item.property.multi) {
                        const arr = [];
                        item.property.data.forEach(item2 => {
                            if (value.includes(item2.key)) {
                                arr.push(item2['name' + this.$lang2]);
                            }
                        })
                        item.value = arr.join();
                    } else {
                        item.value = item.property.data.find(item2 => value.includes(item2.key))?.['name' + this.$lang2];
                    }
                } else {
                    item.value = value || '';
                }
            }
		}
	}
}
